import React from 'react';
import Logo from './Logo';
import Navigation from './Navigation';
import './navigation.css';

const NavBar = () => {
	return (
		<div className = "navbar-container shadow">
	        <Logo />
        	<Navigation />
		</div>
		)
}

export default NavBar;